// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import router from 'router';
import store from 'store';
import { http, eventus } from 'services';

import i18n from 'init/i18n';
import { BeforeCreate } from 'init/before-create';

import DcNuttremaWeb from './DcNuttremaWeb';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<DcNuttremaWeb/>',
  components: { DcNuttremaWeb },
  beforeCreate() {
    BeforeCreate.init();
  },
  created() {
    http.init();
    eventus.init();
  },
});



// WEBPACK FOOTER //
// ./src/main.js